import React from 'react'
import { ToppingBack } from '../index.styled'

const ToppingBackButton = React.memo(({
	layout,
	subItem,
	subItemIndex,
	onClickBackTopping,
}) => {
	return (
		<ToppingBack className={layout + (subItem.quantity < 0 ? ' back' : '')}
								 onClick={event => onClickBackTopping(event, subItemIndex)}
								 data-testid="btn-back-topping"
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M14.2667 5.73333C13.1333 4.6 11.6 4 10 4H3.8L6.4 1.4L5 0L0 5L5 10L6.4 8.6L3.8 6H10C11.0667 6 12.0667 6.4 12.8 7.2C13.5333 7.93333 14 8.93333 14 10C14 11.0667 13.6 12.0667 12.8 12.8C12.0667 13.6 11.0667 14 10 14H6V16H10C11.6 16 13.1333 15.4 14.2667 14.2667C15.4 13.1333 16 11.6 16 10C16 8.4 15.4 6.86667 14.2667 5.73333Z" fill="white" />
			</svg>
		</ToppingBack>
	)
})
export default ToppingBackButton
ToppingBackButton.displayName = 'ToppingBackButton'
